<template>
    <div>
        <h3 class="h6 block-title border-bottom ps-0 mb-3">
            <i class="text-primary fa fa-fw fa-spa text-muted me-1"></i>
            Abonnements & cures
        </h3>
        <div class="mb-3 row" v-if="treatments && treatments.length > 0">
            <div class="col-6 col-md-4" v-for="(treatment, index) in treatments" :key="index + '-' + treatment.id">
                <div class="block shadow-sm" id="payment-attempt">
                    <div class="block-header bg-primary-lighter">
                        <h3 class="block-title">{{ treatment.name }}</h3>
                    </div>
                    <div class="block-content pb-3">
                        <div class="bg-white p-2 rounded">
                            <span class="fw-bold"></span>
                            <div class="w-100 d-flex flex-column mt-2">
                                <span><b>Quantité restante : </b>{{ treatment.pivot.quantity_left }}</span>
                            </div>
                            <div class="mt-3">
                                <button
                                    :ref="'treatmentRemoveBtn-' + treatment.id"
                                    type="button"
                                    class="btn btn-alt-warning text-warning d-none"
                                    @click="removePrestations(treatment.id, 'treatment')"
                                >
                                    <span>Retirer du panier</span>
                                </button>
                                <button
                                    :ref="'treatmentApplyBtn-' + treatment.id"
                                    type="button"
                                    class="btn btn-primary text-white"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-select-prestas"
                                    @click="changeSelected(treatment, 'treatment')"
                                >
                                    <span>Appliquer au panier</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-3 row" v-if="series && series.length > 0">
            <div class="col-6 col-md-4" v-for="(serie, index) in series" :key="index + '-' + serie.id">
                <div class="block shadow-sm" id="payment-attempt">
                    <div class="block-header bg-primary-lighter">
                        <h3 class="block-title">{{ serie.name }}</h3>
                    </div>
                    <div class="block-content pb-3">
                        <div class="bg-white p-2 rounded">
                            <span class="fw-bold"></span>
                            <div class="w-100 d-flex flex-column mt-2">
                                <span><b>Quantité restante : </b>{{ serie.pivot.quantity_left }}</span>
                            </div>
                            <div class="mt-3">
                                <button
                                    :ref="'serieRemoveBtn-' + serie.id"
                                    type="button"
                                    class="btn btn-alt-warning text-warning d-none"
                                    @click="removePrestations(serie.id, 'serie')"
                                >
                                    <span>Retirer du panier</span>
                                </button>
                                <button
                                    :ref="'serieApplyBtn-' + serie.id"
                                    type="button"
                                    class="btn btn-primary text-white"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modal-select-prestas"
                                    @click="changeSelected(serie, 'serie')"
                                >
                                    <span>Appliquer au panier</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="series && treatments">
            <div v-if="(series.length == 0 && treatments.length == 0)">
                <div class="alert alert-warning" role="alert">
                    <p class="mb-0">
                        Pas d'abonnements ni de cures pour ce client.
                    </p>
                </div>
            </div>
        </div>
        <serie-treatment-modal
            :selected="selected"
            @remove-selected="resetSelected"
        ></serie-treatment-modal>
    </div>
</template>

<script>
import ApiManager from './_core/ApiManager'
import { sync, get } from 'vuex-pathify'

export default {
    data: () => ({
        treatments: null,
        series: null,
        selected: null,
        prepaidPrestations: [],
    }),
    async mounted() {
        if (!this.c_customer?.id) return
        await ApiManager.getSeries(this.c_customer.id).then(res => (this.series = res))
        await ApiManager.getTreatments(this.c_customer.id).then(res => (this.treatments = res))
    },
    computed: {
        c_overlay: sync('overlay'),
        ...sync('overlay@data', {
            c_payments: 'payments',
            c_prepaidPrestations: 'prepaidPrestations'
        }),
        ...get('overlay@data', {
            c_customer: 'customer',
            c_cartItems: 'cartItems',
        }),
    },
    methods: {
        changeSelected(item, type) {
            this.selected = item
            this.selected.type = type
            this.changeBtn(this.selected.id, this.selected.type)
        },
        resetSelected() {
            this.selected = null
        },
        removePrestations(prepaidId, prepaidType) {
            this.c_prepaidPrestations = this.c_prepaidPrestations.filter(p => p.prepaid.id != prepaidId && p.prepaid.type != prepaidType)
            this.changeBtn(prepaidId, prepaidType)
        },
        changeBtn(prepaidId, type) {
            let removeBtn = null
            let applyBtn = null

            if (type == 'treatment') {
                removeBtn = this.$refs['treatmentRemoveBtn-' + prepaidId][0]
                applyBtn = this.$refs['treatmentApplyBtn-' + prepaidId][0]
            } else {
                removeBtn = this.$refs['serieRemoveBtn-' + prepaidId][0]
                applyBtn = this.$refs['serieApplyBtn-' + prepaidId][0]
            }

            if (removeBtn.classList.contains('d-none')) {
                removeBtn.classList.remove('d-none')
                applyBtn.classList.add('d-none')
            } else {
                removeBtn.classList.add('d-none')
                applyBtn.classList.remove('d-none')
            }
        },
    },
}
</script>
